export default "__VITE_ASSET__7f96b30e__"